import React from 'react';
import { InfoAndErrorStyles as styles } from './FormFieldsV3InlineStyles';
import { RedErrorIcon } from 'components/svgs/RedErrorIcon';
import { InfoIcon } from 'components/svgs/InfoIcon';

interface IInfoAndErrorProps {
  errorText?: string;
  infoText?: string;
}

const InfoAndError = ({ errorText, infoText }: IInfoAndErrorProps) => {
  if (!errorText && !infoText) {
    return null;
  }
  return (
    <>
      <div style={styles.infoContainer}>
        {errorText ? (
          <>
            <RedErrorIcon styles={styles.errorIcon} />
            <div style={styles.errorText}>{errorText}</div>
          </>
        ) : null}
        {infoText && !errorText ? (
          <>
            <InfoIcon />
            <div style={styles.info}>{infoText}</div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default InfoAndError;
